"use strict";

document.addEventListener('DOMContentLoaded', function () {

    // Fallback for the prototype (DE)
    const splideI18nDefault = {
        prev: 'Vorheriger Slide',
        next: 'Nächster Slide',
        first: 'Erster Slide',
        last: 'Letzter Slide',
        slideX: 'Gehe zu Slide %s',
        pageX: 'Gehe zu Seite %s',
        play: 'Autoplay starten',
        pause: 'Autoplay pausieren',
        carousel: 'Slider',
        slide: 'Slide',
        select: 'Wähle einen Slide zum Anzeigen',
    };

    // Logic for initialization (Merging of defaults and MODX overrides)
    const i18nConfig = Object.assign({}, splideI18nDefault, window.splideL10n || {});



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('js-hero-slider');

    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide gallerySlider
    // *
    // *

    const gallerySlider = document.getElementsByClassName('js-gallery-slider');

    if (gallerySlider !== null) {
        for (let i = 0; i < gallerySlider.length; i++) {
            new Splide(gallerySlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide imageSlider
    // *
    // *

    const imageSlider = document.getElementsByClassName('js-image-slider');

    if (imageSlider !== null) {
        for (let i = 0; i < imageSlider.length; i++) {
            new Splide(imageSlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *

    const textSlider = document.getElementsByClassName('js-text-slider');

    if (textSlider !== null) {
        for (let i = 0; i < textSlider.length; i++) {
            new Splide(textSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                perPage: 1,
                gap: '3rem',
                i18n: i18nConfig,
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *
    // *

    const textImageSlider = document.getElementsByClassName('js-textimage-slider');

    if (textImageSlider !== null) {
        for (let i = 0; i < textImageSlider.length; i++) {
            new Splide(textImageSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                perPage: 1,
                i18n: i18nConfig,
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide instagramSlider
    // *
    // *
    // *

    const instagramSlider = document.getElementsByClassName('js-instagram-slider');

    if (instagramSlider !== null) {
        for (let i = 0; i < instagramSlider.length; i++) {
            new Splide(instagramSlider[i], {
                type: 'slide',
                perPage: 4,
                rewind: true,
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
                i18n: i18nConfig,
                breakpoints: {
                    1200: {
                        perPage: 3,
                    },
                    768: {
                        perPage: 2,
                    },
                    576: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide testimonialSlider
    // *
    // *
    // *

    const testimonialSlider = document.getElementsByClassName('js-testimonial-slider');

    if (testimonialSlider !== null) {
        for (let i = 0; i < testimonialSlider.length; i++) {
            let splide = new Splide(testimonialSlider[i], {
                type: 'loop',
                perPage: 2,
                rewind: false,
                gap: '30px',
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig,
                breakpoints: {
                    1120: {
                        perPage: 1,
                        gap: '10px',
                        padding: '30px',
                        focus: 'center',
                    }
                }
            }).mount();
        }
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    const anchors = document.querySelectorAll(".js-scrollTo");

    for (const anchor of anchors) {
        anchor.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();

        let href = this.getAttribute("href").split("#");
        let newAnchor = "#my" + href[1]
        let offsetTop = document.querySelector(newAnchor).offsetTop;

        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash link jump to content
    // *
    // *

    window.addEventListener('load', function () {
        let getHash = window.location.hash;
        let elementExists = document.getElementById("my" + getHash.slice(1));

        if (getHash !== null && elementExists !== null) {
            let name = "#my" + getHash.slice(1);
            let offsetTop = document.querySelector(name).offsetTop;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }

    }, false);



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *

    const scrolltotop = document.querySelector(".js-scrolltop");

    if (scrolltotop !== null) {
        // show and hide scrollToTop btn on scroll
        document.addEventListener('scroll', function (e) {
            if (window.scrollY > 300) {
                scrolltotop.classList.add("show");
            } else {
                scrolltotop.classList.remove("show");
            }
        });

        // onclick scroll to top
        scrolltotop.onclick = function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        // onkeydown scroll to top or bottom
        scrolltotop.addEventListener("keydown", function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * anchor nav scrollTo
    // *
    // *

    // get browser width
    let browserWidth = window.innerWidth;
    let anchorBox = document.querySelector('.js-anchor-nav');
    let anchorBoxSticky = document.querySelector('.js-anchor-sticky');

    // check if anchor modul is set to sticky
    if (anchorBoxSticky !== null) {
        window.addEventListener('scroll', function (e) {
            // get pos from anchorbox
            let pos = Math.round(anchorBox.getBoundingClientRect().y);

            if (pos <= 0) {
                anchorBox.classList.add("stick");
            } else {
                anchorBox.classList.remove("stick");
            }
        });
    }

    // check if anchor modul is set
    if (anchorBox !== null) {
        // needed for sticky anchor to calculate offsetTop
        anchorBoxHeight = anchorBox.offsetHeight;

        if (browserWidth > 1280) {
            anchorBoxHeight = anchorBoxHeight;
        } else {
            anchorBoxHeight = 0;
        }

        const anchors = document.querySelectorAll(".js-scrollTo");

        for (const anchor of anchors) {
            anchor.addEventListener("click", clickHandler);
        }

        function clickHandler(e) {
            e.preventDefault();

            let href = this.getAttribute("href").split("#");
            let newAnchor = "#my" + href[1]
            let offsetTop = document.querySelector(newAnchor).offsetTop - anchorBoxHeight;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion open every tab
    // *
    // *

    const title = document.querySelectorAll(".js-accordion-title");

    if (title !== null) {
        for (var i = 0; i < title.length; i++) {
            title[i].onclick = function (e) {
                this.classList.toggle("open");
                this.parentElement.nextElementSibling.classList.toggle("open");

                let expanded = this.getAttribute('aria-expanded');

                if (expanded == 'false') {
                    this.setAttribute('aria-expanded', 'true')
                } else {
                    this.setAttribute('aria-expanded', 'false')
                }
            }
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *

    function externalLinks() {
        for (let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];

            // check if link has same hostname. if not add target blank.
            currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
        }
    };

    externalLinks();




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native parallax replacement
    // *
    // *

    const initParallax = () => {
        const parallaxImages = document.querySelectorAll('.js-parallax');
        if (parallaxImages.length === 0) return;

        const observerOptions = {
            threshold: 0,
            rootMargin: "0px"
        };

        const parallaxObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.dataset.visible = "true";
                } else {
                    entry.target.dataset.visible = "false";
                }
            });
        }, observerOptions);

        parallaxImages.forEach(img => {
            parallaxObserver.observe(img);
            // set initial scale to have some buffer for moving
            img.style.transform = "scale(1.2) translateY(0px)";
        });

        const updateParallax = () => {
            parallaxImages.forEach(img => {
                if (img.dataset.visible === "true") {
                    const rect = img.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const elementHeight = rect.height;
                    const elementCenter = rect.top + elementHeight / 2;
                    const viewportCenter = windowHeight / 2;

                    // calculate distance from center of viewport (-1 to 1)
                    const distance = (elementCenter - viewportCenter) / (windowHeight / 2 + elementHeight / 2);
                    const movement = distance * 50; // shift by 50px max

                    img.style.transform = `scale(1.2) translateY(${movement}px)`;
                }
            });
            requestAnimationFrame(updateParallax);
        };

        requestAnimationFrame(updateParallax);
    };

    initParallax();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native aos replacement (Intersection Observer)
    // *
    // *

    const aosElements = document.querySelectorAll('[data-aos]');

    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const aosObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('aos-animate');
                if (entry.target.getAttribute('data-aos-once') !== 'false') {
                    observer.unobserve(entry.target);
                }
            } else {
                if (entry.target.getAttribute('data-aos-once') === 'false') {
                    entry.target.classList.remove('aos-animate');
                }
            }
        });
    }, observerOptions);

    aosElements.forEach(element => {
        aosObserver.observe(element);
    });


    
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * footer logo animation
    // *
    // *

    const footerLogo = document.querySelector('.footer__logo-svg');

    if (footerLogo !== null) {
        const logoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                } else {
                    entry.target.classList.remove('is-visible');
                }
            });
        }, {
            threshold: 0.5 // Trigger when 50% of the logo is visible
        });

        logoObserver.observe(footerLogo);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * overlay menu toggle
    // *
    // *

    const menuTriggers = document.querySelectorAll('.js-menu-trigger');
    const menuCloses = document.querySelectorAll('.js-menu-close');
    const overlayMenu = document.querySelector('.overlay-menu');

    if (overlayMenu) {
        const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        let lastFocusedElement = null;
        let focusTrapHandler = null;

        // Hide from tab order when closed
        overlayMenu.setAttribute('inert', '');

        function openMenu() {
            overlayMenu.removeAttribute('inert');
            overlayMenu.classList.add('is-visible');
            document.body.classList.add('no-scroll');

            // Focus trap: cycle Tab within overlay
            const focusableElements = Array.from(overlayMenu.querySelectorAll(focusableSelectors));
            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];

            focusTrapHandler = (e) => {
                if (e.key !== 'Tab') return;
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusable) {
                        e.preventDefault();
                        lastFocusable.focus();
                    }
                } else {
                    if (document.activeElement === lastFocusable) {
                        e.preventDefault();
                        firstFocusable.focus();
                    }
                }
            };

            overlayMenu.addEventListener('keydown', focusTrapHandler);

            // Set focus to first focusable element (close button)
            if (firstFocusable) firstFocusable.focus();
        }

        function closeMenu(restoreFocus = true) {
            overlayMenu.classList.remove('is-visible');
            overlayMenu.setAttribute('inert', '');
            document.body.classList.remove('no-scroll');

            if (focusTrapHandler) {
                overlayMenu.removeEventListener('keydown', focusTrapHandler);
                focusTrapHandler = null;
            }

            // Restore focus to the element that opened the menu
            if (restoreFocus && lastFocusedElement) {
                lastFocusedElement.focus();
                lastFocusedElement = null;
            }
        }

        // Open / Toggle
        menuTriggers.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                if (overlayMenu.classList.contains('is-visible')) {
                    closeMenu();
                } else {
                    lastFocusedElement = btn;
                    openMenu();
                }
            });
        });

        // Close button
        menuCloses.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                closeMenu();
            });
        });

        // Close on click outside (background)
        overlayMenu.addEventListener('click', (e) => {
            if (e.target === overlayMenu) {
                closeMenu();
            }
        });

        // Close on ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && overlayMenu.classList.contains('is-visible')) {
                closeMenu();
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * overlay menu submenu toggle
    // *
    // *
    // *

    const submenuToggles = document.querySelectorAll('.js-submenu-toggle');

    if (submenuToggles) {
        submenuToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                toggle.classList.toggle('active');

                // Toggle aria-expanded
                const expanded = toggle.getAttribute('aria-expanded') === 'true' || false;
                toggle.setAttribute('aria-expanded', !expanded);

                // Find sibling submenu
                // Structure: .overlay-menu__item-header > toggle -> sibling of header is submenu
                const parentHeader = toggle.closest('.overlay-menu__item-header');
                if (parentHeader) {
                    const submenu = parentHeader.nextElementSibling;
                    if (submenu && submenu.classList.contains('overlay-menu__submenu')) {
                        submenu.classList.toggle('open');
                    }
                }
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header on scroll
    // *
    // *
    // *

    const header = document.querySelector('.header');

    if (header) {
        const headerScroll = () => {
            if (window.scrollY > 50) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        };

        window.addEventListener('scroll', headerScroll);
        window.addEventListener('load', headerScroll);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroColsTeaser toggle
    // *
    // *
    // *

    document.addEventListener('click', function (e) {
        // Toggle Button OR Header Click
        const target = e.target;
        const toggleBtn = target.closest('.heroColsTeaser__toggle');
        const header = target.closest('.heroColsTeaser__header');

        if (toggleBtn || header) {
            const item = target.closest('.heroColsTeaser__item');
            
            if (item) {
                // Prevent bubbling if needed, though event delegation handles it
                // e.stopPropagation(); 

                const isOpen = item.classList.contains('is-open');
                const allItems = document.querySelectorAll('.heroColsTeaser__item');

                // Close all other items (Accordion behavior)
                allItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('is-open');
                        const otherBtn = otherItem.querySelector('.heroColsTeaser__toggle');
                        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                    }
                });

                // Toggle current item
                if (isOpen) {
                    item.classList.remove('is-open');
                    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
                } else {
                    item.classList.add('is-open');
                    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
                }
            }
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpen = document.querySelector(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");

    /* onclick show modal window */
    if (modalOpen !== null) {
        modalOpen.onclick = function () {
            if (typeof modalWindow.showModal === "function") {
                modalWindow.showModal();
            } else {
                modalWindow.style.display = "block";
            }
            modalClose.focus();
        }
    }

    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = function () {
            if (typeof modalWindow.close === "function") {
                modalWindow.close();
            } else {
                modalWindow.style.display = "none";
            }
        }
    }

    /* clicks anywhere outside close modal window */
    window.onclick = function (event) {
        if (event.target == modalWindow) {
            if (typeof modalWindow.close === "function") {
                modalWindow.close();
            } else {
                modalWindow.style.display = "none";
            }
        }
    }


});
